import { Modal } from "antd"
type LoginModalProps = {
  visible: boolean
  onCancel: () => void
  onOk: () => void
}
export default function LoginModal({
  visible,
  onCancel,
  onOk,
}: LoginModalProps) {
  return (
    <div>
      <Modal
        title="提示"
        visible={visible}
        okText="去登录"
        onOk={onOk}
        onCancel={onCancel}
      >
        您还没有登录，请先登录！
      </Modal>
    </div>
  )
}
